import { Outlet } from "@tanstack/react-router";

import { TanstackErrorComponent } from "@/components/tanstack-error-component";
import { TanstackNotfoundComponent } from "@/components/tanstack-notfound-component";
import { useActiveOrganization } from "@/context/active-organization-provider";

export const Route = createFileRoute({
  component: RouteComponent,
  errorComponent: TanstackErrorComponent,
  notFoundComponent: TanstackNotfoundComponent,
});

function RouteComponent() {
  const { orgId } = Route.useParams();
  const { activeOrganization, setActiveOrganization } = useActiveOrganization();

  if (orgId !== activeOrganization.id) {
    setActiveOrganization(orgId);
    return <div>Chaning Organizations...</div>;
  }

  return <Outlet />;
}
